<template lang="pug">
  div
    Navbar(:on-go-back="goBack")

    form(@submit.prevent="submit")
      .l-content
        .l-container
          .c-container
            .u-ptxl
              span.u-anim-slideup 携帯電話番号を入力してください

        .l-container
          .c-container.is-form
            .c-cells-table__title 携帯電話番号
            .c-cells-table
              .c-cells-table-cell__input
                input(
                  type="number"
                  autofocus
                  required="true"
                  name="tel"
                  v-model="state.tel"
                  placeholder="例）09012345678")

        .l-container(v-if="isTelExists")
          .c-container
            router-link(:to="{ name: 'verifyPhoneNumberAuthorization' }") 既に認証番号をお持ちの方はこちら

        .l-container
          .c-container
            .u-color-gray ※電話番号は公開されません。
            .u-color-gray 必要に応じて担当者からご連絡を差し上げる場合がございます。

        .l-container
          FloatingButton(:disabled="disabled" type="submit")
</template>

<script lang="babel">
import FloatingButton from "@/components/button/FloatingButton";
import ApiAlertMixin from "@/mixins/ApiAlertMixin";
import Navbar from "@/components/navbar/Navbar";
import PlatformTypeMixin from "@/mixins/PlatformTypeMixin";
import { CURRENT_STEP_KEY } from "@/constants/localStorageKeys";
import nativeMethodDispatcher from "@/utils/nativeMethodDispatcher";
import {computed, defineComponent, onMounted, reactive} from "vue";
import {useRoute, useRouter} from "vue-router/composables";
import {inject} from "vue";
import {SIGNUP_STORE} from "@/constants/InjectionKeys";
import PhoneNumberAuthorization from "@/api/phone_number_authorization";
import {useAlert} from "@/composables/useAlert";
import {usePlatformType} from "@/composables/usePlatformType";

export default defineComponent({
  name: 'PhoneNumberAuthorization',
  components: { Navbar, FloatingButton },
  mixins: [ ApiAlertMixin, PlatformTypeMixin ],
  setup(_, { emit }) {
    emit('page-navbar', false);

    const route = useRoute()
    const { worker, setWorker } = inject(SIGNUP_STORE)

    const setEmailFromQueryIfNotExists = () => {
      if (!worker.email) {
        const email = route.query.email;
        setWorker({ ...worker, email: email });
      }

      return worker.email != null;
    }

    // クエリかローカルストレージにメアドがあれば正規のアクセス扱いにする
    if (setEmailFromQueryIfNotExists()) {
      localStorage.setItem(CURRENT_STEP_KEY, 'phoneNumberAuthorization');
    }

    // パラメーター引き継ぎ
    if (!worker.referrer && route.query.referrer != null) {
      const referrer = Number(route.query.referrer);
      setWorker({ ...worker, referrer: referrer });
    }

    const state = reactive({ tel: null })
    const disabled = computed(() => state.tel == null || state.tel.length !== 11)
    const isTelExists = computed(() => worker.tel != null)

    const router = useRouter()
    const goBack = (_goBack) => {
      const { isIos, isAndroid } = usePlatformType()
      if (isIos() || isAndroid()) {
        nativeMethodDispatcher.dispatch('close');
      } else {
        router.push({ name: 'home' });
      }
    }

    const { showErrorAlert } = useAlert()
    const submit = () => {
      emit('loading', true);

      PhoneNumberAuthorization.regist({ tel: state.tel })
        .then(() => {
          setWorker({ ...worker, tel: state.tel })
          router.push({ name: "verifyPhoneNumberAuthorization" });
        })
        .catch(showErrorAlert)
        .finally(() => {
          emit('loading', false)
        });
    }

    return { state, disabled, isTelExists, goBack, submit }
  }
})
</script>

<style lang="scss" scoped>
.c-container {
  &.is-form {
    .c-cells-table__title,
    .c-cells-table-cell__input > input::placeholder {
      color: #CAC9C9;
    }
    .c-cells-table-cell__input > input {
      letter-spacing: 0.03rem;
    }
  }
  span {
    font-size: 18px;
    line-height: 18px;
    letter-spacing: 0.03em;
  }
  .c-cells-table-cell {
    padding: 0px;
    box-shadow: none;
    .c-cells-table-cell__action{
      padding: 0px;
    }
    .c-cells-table-cell__action.is-check {
      .material-icons {
        background: #FFFFFF;
        border: 1px solid #E5E5E5;
        box-sizing: border-box;
        border-radius: 6px;
        border-radius: 5px;
      }
      &.success {
        .material-icons {
          color: #F94848;
        }
      }
    }
  }
  .c-cells-table__title {
    color: #222222;
    padding: {
      right: 0;
      left: 0;
    }
  }
  .c-cells-table-cell__input {
    input[type="number"] {
      padding: 10px 0;
      box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
